import { render, staticRenderFns } from "./graph_top3.vue?vue&type=template&id=15250986&"
import script from "./graph_top3.vue?vue&type=script&lang=js&"
export * from "./graph_top3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports